export default __webpack_public_path__ + "static/media/lc.1daaf19b.mp4";